import { normalizedFactors, reducedDimensions } from './reducedDimensions.js';
function deriveBoxAverageGrid(source, reduction) {
    const factors = normalizedFactors(reduction.factors);
    const sourceOffset = (reduction.sourceOffset ?? [0, 0, 0]);
    const sourceDimensions = (reduction.sourceDimensions ??
        source.dimensions);
    for (let axis = 0; axis < 3; axis++) {
        const offset = sourceOffset[axis];
        const size = sourceDimensions[axis];
        if (!Number.isInteger(offset) || offset < 0 || size < 1) {
            throw new Error(`deriveBoxAverageGrid: the region [${sourceOffset}] +[${sourceDimensions}] is not valid`);
        }
        if (offset + size > source.dimensions[axis]) {
            throw new Error(`deriveBoxAverageGrid: the region [${sourceOffset}] +[${sourceDimensions}] leaves the source grid [${source.dimensions}]`);
        }
    }
    const origin = [...source.origin];
    const spacing = [1, 1, 1];
    for (let axis = 0; axis < 3; axis++) {
        spacing[axis] = source.spacing[axis] * factors[axis];
        const shift = source.spacing[axis] * (sourceOffset[axis] + (factors[axis] - 1) / 2);
        origin[0] += source.direction[axis * 3] * shift;
        origin[1] += source.direction[axis * 3 + 1] * shift;
        origin[2] += source.direction[axis * 3 + 2] * shift;
    }
    return {
        origin,
        direction: Array.from(source.direction),
        spacing,
        dimensions: reducedDimensions(sourceDimensions, factors),
    };
}
export { deriveBoxAverageGrid as default, deriveBoxAverageGrid };
